module.exports = __webpack_public_path__ + "static/media/empty-sales.594104ad.svg";